import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";

export interface MutateUserResendVerificationParams {
  emailAddress: string;
}

export const mutateUserResendVerification = async (
  values: MutateUserResendVerificationParams
) => {
  const response = await makeMutation(
    ApiEndpoints.userResendVerification(),
    values
  );
  return { success: response.success };
};
